<template>
  <jd-dialog
    align-center
    :visible.sync="visible"
    :show-close="true"
    title="批量发货"
    width="590px"
    :before-close="close"
    :isShowSure="false"
    :isShowCancel="false"
  >
    <div class="lead_first" v-loading="loading">
      <span>上传文件：</span>
      <el-upload
        :before-upload="beforeUpload"
        :on-success="handleUpload"
        :on-error="handleError"
        :show-file-list="false"
        class="upload-demo"
        ref="upload"
        :action="action"
        drag
        multiple
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或 <em>点击上传</em></div>
      </el-upload>

      <jd-button type="blue" style="margin-left: 19px" @click="handleUrl">
        下载模板
      </jd-button>
    </div>
    <div style="margin-top: 10px;">
      导入成功{{ failureObj.successNum }}条，导入失败{{
        failureObj.failNum
      }}条，导入失败相关{{name}}：
    </div>
    <template v-if="failureObj.failNum > 0">
      <div
        style="margin-top: 10px; font-size: 16px"
        v-for="(item, index) in failureObj.failUserName"
        :key="index"
      >
        {{ item }}
      </div>
    </template>
    <span slot="footer" class="dialog-footer">
      <jd-button type="blue" style="margin-right: 8px;" @click="submit">确定</jd-button>
      <jd-button @click="close">取消</jd-button>
    </span>
  </jd-dialog>
</template>

<script>
export default {
  name: "BatchUpload",
  props: {
    visible: Boolean,
    activityId: {
      type: String,
      default: "",
    },
    action:{
      require:true,
      type:String
    },
    name:{
      type:String,
      default:'用户昵称'
    }
  },
  data() {
    return {
      failureObj: {
        successNum: 0,
        failNum: 0,
        failUserName: [],
      },
      loading: false,
    };
  },
  methods: {
    submit() {
      this.$emit("close", false);
    },
    close() {
      this.$emit("close", false);
    },

    beforeUpload(file) {
      // let formData = new FormData();
      // formData.append("file", file);
      // console.log(res, 333333);
      // let res = {
      //   data: {},
      // };
      // failureObj.successNum = res.data.successNum;
      // failureObj.failNum = res.data.failNum;
      // failureObj.failUserName = res.data.failUserName;
      this.loading = true;
    },
    handleUpload(res) {
      if (res.code == 1) {
        this.failureObj.successNum = res.data.successNum;
        this.failureObj.failNum = res.data.failNum;
        this.failureObj.failUserName = res.data.failUserName;
      } else {
        this.$message.error(res.message);
      }
      this.loading = false;
    },
    handleError() {
      this.loading = false;
    },
    handleUrl() {
      const url =
        "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/%E6%89%B9%E9%87%8F%E5%8F%91%E8%B4%A7%E6%A8%A1%E6%9D%BF2.xlsx";
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      elem.setAttribute("download", "导入模板.xlsx");
      document.body.appendChild(elem);
      elem.click();
    },
  },
};
</script>

<style scoped lang="scss">
.lead_first {
  display: flex;
}
</style>
